import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderThumbnailsFragment = { __typename?: 'FolderAsset', id: string, deletedAt?: string | null, thumbnails?: Array<{ __typename?: 'FolderThumbnailFileItem', id: string, filetype?: Types.Filetype | null, name: string, thumbnailImageUrl?: { __typename?: 'ImageTranscodeUrl', url: string } | null } | { __typename?: 'FolderThumbnailFolderItem', id: string, fileCount: number, name: string }> | null };

export const FolderThumbnails = /*#__PURE__*/ gql`
    fragment FolderThumbnails on FolderAsset {
  id
  deletedAt
  thumbnails {
    name
    ... on FolderThumbnailFileItem {
      id
      filetype
      thumbnailImageUrl {
        url
      }
    }
    ... on FolderThumbnailFolderItem {
      id
      fileCount
    }
  }
}
    ` as unknown as DocumentNode<FolderThumbnailsFragment, unknown>;

        

        
export const useFolderThumbnailsFragment = (
  input: string | Omit<UseFragmentOptions<FolderThumbnailsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderThumbnailsFragment>({
    fragment: FolderThumbnails,
    fragmentName: 'FolderThumbnails',
    ...options,
  });
};
  
        